<!-- eslint-disable max-len -->
<template>
  <div>
    <Card title="Subscription">
      <template v-slot:body>
        <div>
          <div class="pb-3 flex justify-between items-center w-full">
            <div class="flex items-center w-full">
              <el-row class="w-full" gutter="10">
                <el-col span="8">
                  <date-range-picker
                    ref="picker"
                    :timePicker="false"
                    :showDropdowns="false"
                    :max-date="maxDate"
                    v-model="dateRange"
                    :opens="'right'"
                    @update="onChangeDate"
                    :auto-apply="true"
                    class="w-full"
                  >
                    <template v-slot:input="picker" >
                      From: {{ moment(picker.startDate) }} - To: {{ moment(picker.endDate) }}
                    </template>
                  </date-range-picker>
                </el-col>
                <el-col span="8">
                  <el-input placeholder="search" v-model="filter.q" @change="search" class="w-full" ></el-input>
                </el-col>
                <el-col span="8">
                  <el-select
                    filterable placeholder="Select Channel"
                    v-model="filter.channel"
                    @change="search"
                    class="w-full"
                  >
                    <el-option :value="v.key" v-for="v in paymentChannels" :key="`channel-${v.key}`">>{{ v.value }}</el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="pb-3 flex justify-between items-center w-full">
            <div class="flex items-center w-full">
              <el-row class="w-full" gutter="10">
                <el-col span="8">
                  <el-select
                    filterable placeholder="Select Type"
                    v-model="filter.type"
                    @change="search"
                    class="w-full"
                  >
                    <el-option :value="v.key" v-for="v in paymentTypes" :key="`type-${v.key}`">{{ v.value }}</el-option>
                  </el-select>
                </el-col>
                <el-col span="8">
                  <el-select
                    filterable placeholder="Select Status"
                    v-model="filter.status"
                    @change="search"
                    class="w-full"
                  >
                    <el-option :value="v.key" v-for="v in paymentStatuses" :key="`status-${v.key}`">{{ v.value }}</el-option>
                  </el-select>
                </el-col>
                <el-col span="8">
                  <el-select
                    filterable placeholder="First Time?"
                    v-model="filter.first_time"
                    @change="search"
                    class="w-full"
                  >
                    <el-option :value="null">All</el-option>
                    <el-option :value="true">Yes</el-option>
                    <el-option :value="false">No</el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="pb-6 flex" style="gap: 16px;">
            <card-stats
              statSubtitle="Subscription Revenue"
              :statTitle="`$${formatPrice(parseFloat(total_subscription_history).toFixed(2))}`"
            />
            <card-stats
              statSubtitle="Gross Revenue"
              :statTitle="`$${formatPrice(parseFloat(gross_subscription_history).toFixed(2))}`"
            />
          </div>
          <data-tables-server ref="tableTransaction" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [displayingItem] }" @query-change="onChangeTable" style="width: 100%">
            <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" width="200" :key="title.prop" sortable="custom">
            </el-table-column>
            <el-table-column  label="Actions" align="right" width="110px" fixed="right">
              <template slot-scope="scope">
                <div class="static inline-block text-left container-action">
                  <VueCustomTooltip label="Detail" :position="'is-left'">
                    <button @click="detail(scope.row)" class="p-2 w-8 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none" >
                      <font-awesome-icon class="text-white" :icon="['fa', 'eye']" />
                    </button>
                  </VueCustomTooltip>
                </div>
              </template>
            </el-table-column>
          </data-tables-server>
        </div>
      </template>
    </Card>
    <ModalDialogDetail
      :isShowingModal="toggleDetail"
      title="Transaction Details"
      @toggleModal="toggleDetail = !toggleDetail"
    >
      <template slot="body" >
        <div class="py-4">
          <div class="flex">
            <div class="w-1/2">
              <form-item label='TRX ID'>
                <template v-slot>
                  <p class="text-left font-bold">{{ detailTrans!=null?(detailTrans.trx_id || '-'):'-' }}</p>
                </template>
              </form-item>
              <form-item label='Email'>
                <template v-slot>
                  <p class="text-left font-bold">{{ detailTrans!=null?detailTrans.email:'-' }}</p>
                </template>
              </form-item>
              <form-item label='Status'>
                <template v-slot>
                  <p class="text-left font-bold">{{ detailTrans!=null?detailTrans.status_text:'-' }}</p>
                </template>
              </form-item>
              <form-item label='Channel'>
                <template v-slot>
                  <p class="text-left font-bold">{{ detailTrans!=null?detailTrans.channel_name:'-' }}</p>
                </template>
              </form-item>
              <form-item label='Type'>
                <template v-slot>
                  <p class="text-left font-bold">{{ detailTrans!=null?detailTrans.type:'-' }}</p>
                </template>
              </form-item>
              <form-item label='Currency'>
                <template v-slot>
                  <p class="text-left font-bold">{{ detailTrans!=null?detailTrans.original_currency:'-' }}</p>
                </template>
              </form-item>
            </div>
            <div class="w-1/2">
              <form-item label='Price'>
                <template v-slot>
                  <p class="text-left font-bold">{{ detailTrans!=null?`${detailTrans.original_currency} ${this.formatPrice(parseFloat(detailTrans.original_price).toFixed(2))}`:'-' }}</p>
                </template>
              </form-item>
              <form-item label='Fee'>
                <template v-slot>
                  <p class="text-left font-bold">{{ detailTrans!=null?`${detailTrans.original_currency} ${this.formatPrice(parseFloat(detailTrans.fee).toFixed(2))}`:'-' }}</p>
                </template>
              </form-item>
              <form-item label='Net'>
                <template v-slot>
                  <p class="text-left font-bold">{{ detailTrans!=null?`${detailTrans.original_currency} ${this.formatPrice(parseFloat(detailTrans.net_revenue).toFixed(2))}`:'-' }}</p>
                </template>
              </form-item>
              <form-item label='Final Currency'>
                <template v-slot>
                  <p class="text-left font-bold">{{ detailTrans!=null?detailTrans.final_currency:'-' }}</p>
                </template>
              </form-item>
              <form-item label='Final Price'>
                <template v-slot>
                  <p class="text-left font-bold">{{ detailTrans!=null?detailTrans.final_price_text:'-' }}</p>
                </template>
              </form-item>
              <form-item label='Final Fee'>
                <template v-slot>
                  <p class="text-left font-bold">{{ detailTrans!=null?detailTrans.fee_text:'-' }}</p>
                </template>
              </form-item>
              <form-item label='Final Net'>
                <template v-slot>
                  <p class="text-left font-bold">{{ detailTrans!=null?detailTrans.net_price_text:'-' }}</p>
                </template>
              </form-item>
            </div>
          </div>


        </div>
      </template>
    </ModalDialogDetail>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import helperMixins from '../mixins/helpers.mixins';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import ModalDialogDetail from '../components/Common/ModalDialogDetail';
import moment from 'moment';
import { Button, FormItem } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card.vue';
import CardStats from '@/components/Layout/CardStats.vue';

const displayingItems = 50;

export default {
  name: 'SubscriptionHistoryPage',
  mixins: [helperMixins],
  data() {
    return {
      isLoading: false,
      utc_offset: Math.floor(moment().utcOffset() / 60),
      data: [],
      total: 0,
      displayingItem: displayingItems,
      titles: [{
        prop: 'trx_id',
        label: 'TRX ID',
      }, {
        prop: 'date',
        label: 'Date',
      }, {
        prop: 'email',
        label: 'Email',
      }, {
        prop: 'channel_name',
        label: 'Channel',
      }, {
        prop: 'type',
        label: 'Type',
      }, {
        prop: 'duration_text',
        label: 'Duration',
      }, {
        prop: 'final_price_text',
        label: 'Paid Amount',
      }, {
        prop: 'fee_text',
        label: 'Fee',
      }, {
        prop: 'net_price_text',
        label: 'Net Amount',
      }, {
        prop: 'end_date_text',
        label: 'End Date',
      }, {
        prop: 'status_text',
        label: 'Status',
      }],
      filter: {
        page: 1,
        per_page: displayingItems,
        q: '',
        channel: null,
        type: null,
        status: null,
        sortby: 'trx_id',
        sortorder: 'desc',
        start_date: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
        first_time: null,
      },
      dateRange: {
        startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      },
      maxDate: moment().format('YYYY-MM-DD'),
      detailTrans: null,
      toggleDetail: false,
      paymentChannels: [
        {
          key: null,
          value: 'All Channel',
        },
        {
          key: 'credit',
          value: 'Credit Card',
        },
        {
          key: 'wechat',
          value: 'Wechat',
        },
        {
          key: 'in-app',
          value: 'In App Purchase',
        },
        {
          key: 'apple_pay',
          value: 'Apple Pay',
        },
        {
          key: 'gcash',
          value: 'GCash',
        },
        {
          key: 'grab_pay',
          value: 'Grab Pay',
        },
      ],
      paymentStatuses: [
        {
          key: null,
          value: 'All Status',
        },
        {
          key: 99,
          value: 'Pending',
        },
        {
          key: 1,
          value: 'Success',
        },
        {
          key: 2,
          value: 'Scheduled',
        },
        {
          key: 3,
          value: 'Failed',
        },
      ],
      paymentTypes: [
        {
          key: null,
          value: 'All Types',
        },
        {
          key: 1,
          value: 'Recurring',
        },
        {
          key: 2,
          value: 'One Time',
        },
      ]
    };
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListSubscriptionHistory(this.filter);
  },
  computed: {
    ...mapGetters('TransactionAdminModule', ['list_subscription_history', 'total_subscription_history', 'gross_subscription_history']),
  },
  watch: {
    list_subscription_history: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (this.list_subscription_history.data !== undefined) {
          this.data = this.list_subscription_history.data.data.map((purchase) => {
            return { ...purchase,
              final_price_text: `${purchase.final_currency ? purchase.final_currency : ''} ${purchase.final_price ? this.formatPrice(parseFloat(purchase.final_price).toFixed(2)) : '-'}`,
              net_price_text: `${purchase.final_currency ? purchase.final_currency : ''} ${purchase.final_net_revenue ? this.formatPrice(parseFloat(purchase.final_net_revenue - purchase.billing_fee).toFixed(2)) : '-'}`,
              fee_text: `${purchase.final_currency ? purchase.final_currency : ''} ${purchase.final_fee ? this.formatPrice(parseFloat(purchase.final_fee + purchase.billing_fee).toFixed(2)) : '-'}`,
              date: moment(purchase.date).format('YYYY-MM-DD HH:mm:ss'),
              end_date_text: moment(purchase.end_date).format('YYYY-MM-DD'),
              duration_text: `${purchase.duration} ${purchase.duration_unit}`,
              channel_name: this.getChannelName(purchase.payment_method),
              type: purchase.recurring ? 'Recurring' : 'One Time'
            };
          });
          this.total = this.list_subscription_history.data.total;
        }
      },
    },
  },
  methods: {
    ...mapActions('TransactionAdminModule', ['requestListSubscriptionHistory']),
    async search() {
      await this.requestListSubscriptionHistory(this.filterFormatUtc({}));
    },
    moment(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    filterFormatUtc(params){
      const startUtc = moment(this.filter.start_date).utc().format('YYYY-MM-DD HH:mm:ss');
      const endUtc = moment(this.filter.end_date).utc().format('YYYY-MM-DD HH:mm:ss');
      return {
        ...this.filter,
        ...params,
        start_date: startUtc,
        end_date: endUtc,
      }
    },
    async reset() {
      this.$refs.tableTransaction.$refs.elTable.clearSort();
      this.filter = {
        page: 1,
        per_page: this.displayingItem,
        sortby: 'trx_id',
        sortorder: 'desc',
        q: '',
        channel: '',
        start_date: '',
        end_date: '',
        first_time: null,
      };
      this.search();
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filter = Object.assign(this.filter, { per_page: this.displayingItem, sortorder, sortby, page });
      await this.requestListSubscriptionHistory(this.filterFormatUtc({}));
    },
    async onChangeDate(res) {
      this.filter = { ...this.filter,
        start_date: moment(res.startDate).format('YYYY-MM-DD'),
        end_date: moment(res.endDate).format('YYYY-MM-DD'),
      };
      await this.search();
    },
    detail(row) {
      this.detailTrans = row;
      this.toggleDetail = true;
    },
    getChannelName(key){
      if(key === null || key === ""){
        return 'Credit Card'
      }else{
        switch (key) {
          case 'credit':
            return 'Credit Card'
          case 'wechat':
            return 'Wechat'
          case 'grab_pay':
            return 'Grab Pay'
          case 'gcash':
            return 'GCash'
          case 'in-app':
            return 'In App'
          case 'applepay':
            return 'Apple Pay'
          case 'apple_pay':
            return 'Apple Pay'
        }
      }
    }
  },
  components: {
    VueCustomTooltip, DateRangePicker, ModalDialogDetail,
    Button,
    Card,
    CardStats,
    FormItem
  },
};
</script>
<style>
.el-table th>.cell{
  word-break: break-word;
}
</style>
<style scoped>
.z-1000{
  z-index: 1000;
}
.mx-400{
  max-height: 50%;
  height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/views/SubscriptionHistory.vue